import React, { useMemo, useState } from "react";
import {
  GenericDiv,
  FlexRowBetween,
  Input,
  Label,
  PopupForm,
  TodoCard,
  ListHolder,
} from "../common/Style";
import OpacityLoading from "../common/loader/OpacityLoading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getTalsCalls } from "../../store/reducers/todosReducer";
import { countNotAnswered } from "../../store/reducers/dataReducer";
import CopyText from "../common/others/CopyText";

const SearchTalsTodos = ({ init }) => {
  const dispatch = useDispatch();
  const { todosLoading } = useSelector((state) => state.todosReducer);
  const { todos } = useSelector((state) => state.todosReducer);

  const [talsPhone, setTalsPhone] = useState("");
  const [showLoading, setShowLoading] = useState(false);

  const handleGetTalsCalls = () => {
    dispatch(getTalsCalls({ tal: talsPhone })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
    });
  };

  const handleCountNotAnswered = (uid) => {
    setShowLoading(true);
    dispatch(countNotAnswered({ uid })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else
        toast.info(
          <div>
            <FlexRowBetween>
              <div>{res.payload.amount}</div>
              <CopyText
                marginLeft={"5px"}
                dataToCopy={`${res.payload.phone}`}
                text={res.payload.phone}
              />
            </FlexRowBetween>
          </div>
        );
      setShowLoading(false);
    });
  };

  let todosArray = useMemo(() => {
    let today = new Date();
    let arr = [];
    let sortedArray = [];
    if (Object.keys(todos).length > 0) {
      for (const [key, value] of Object.entries(todos)) sortedArray.push(value);
      sortedArray.sort(
        (a, b) => new Date(a["executionDate"]) - new Date(b["executionDate"])
      );
      for (let i = 0; i < sortedArray.length; i++)
        arr.push(
          <TodoCard
            onClick={() => handleCountNotAnswered(sortedArray[i].uid)}
            style={{
              cursor: "text",
              background: sortedArray[i].done ? "#dce3f0" : "white",
            }}
            key={i}
          >
            <div>{sortedArray[i].title}</div>
            <div>
              <div style={{ fontSize: "13px" }}>
                {sortedArray[i].executionDate
                  .replace(/T.*/, "")
                  .split("-")
                  .reverse()
                  .join("/")}
              </div>
            </div>
          </TodoCard>
        );
    }
    return arr;
  }, [todos]);

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      className="animate__animated animate__fadeIn"
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <FlexRowBetween style={{ marginTop: "10px", alignItems: "flex-end" }}>
          <div>
            <Label>מספר נייד</Label>
            <Input type="text" onChange={(e) => setTalsPhone(e.target.value)} />
          </div>
          <GenericDiv
            onClick={() => handleGetTalsCalls()}
            // style={{ width: "100%" }}
          >
            חיפוש שיחות
          </GenericDiv>
        </FlexRowBetween>

        <ListHolder style={{ marginTop: "20px" }}>{todosArray}</ListHolder>
        <div style={{ height: "100px" }} />
      </div>

      {(todosLoading || showLoading) && <OpacityLoading />}
    </PopupForm>
  );
};

export default SearchTalsTodos;
